// extracted by mini-css-extract-plugin
export var formContainer = "_ky-0";
export var message = "_ky-1";